export type IdPasswordCategoryType = {
    value: string;
    label: string;
  }
  
  export const ID_PASSWORD_CATEGORY_LIST: IdPasswordCategoryType[] = [
    {
      value: 'software_tally.ERP_9',
      label: 'Software - Tally.ERP 9'
    },
    {
      value: 'software_tally_remote_access',
      label: 'Software - Tally Remote Access'
    },
    {
      value: 'software_compuOffice',
      label: 'Software - CompuOffice'
    },
    {
      value: 'software_others',
      label: 'Software - Others'
    },
    {
      value: 'website_income_tax',
      label: 'Website - Income Tax'
    },
    {
      value: 'website_gst',
      label: 'Website - GST'
    },
    {
      value: 'website_tenders',
      label: 'Website - Tenders'
    },
    {
      value: 'website_others',
      label: 'Website - Others'
    },
    {
      value: 'others',
      label: 'Others'
    }
  ];
  